export default "__VITE_ASSET__CShB1_xZ__"